export const engagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestion =
  "/engagement/landing_pages/:app_group_id/survey_landing_pages_with_question";
